import React, { useState } from "react";
import FadeInSection from "./FadeInSection"; // Keeps animation

import DecisionAgentInstructions from "./DecisionAgentInstructions";
import DecisionAgentDemoSetup from "./DecisionAgentDemoSetup";
import DecisionAgentOptimization from "./DecisionAgentOptimization";

import "./DecisionAgent.css"; // Keep the original styles

const DecisionAgentHeader = () => {
    return (
      <>
        
        <img
          src={`${process.env.PUBLIC_URL}/niche_agents.svg`} 
          alt="Niche Agents" 
          className="agent-image"
        />
        
        <h2 className="decision-agent-title">Niche Agents</h2>
        <p className="decision-agent-description">
          Modlee accelerates your niche agent development, and helps you optimize agent tasks for scalability when you're ready.
        </p>
        {/* <div className="decision-agent-grid">
          <div className="decision-agent-item">
            <h3 className="decision-agent-subtitle">Build Your Way</h3>
            <p className="decision-agent-text">
              Use Modlee's foundational Agents alongside any other LLM within your custom Agent Python class and task definitions.
            </p>
          </div>
          <div className="decision-agent-item">
            <h3 className="decision-agent-subtitle">Effortless Integration</h3>
            <p className="decision-agent-text">
              Integrate inefficient tasks into Modlee’s agent package with just a few lines of code.            </p>
          </div>
          <div className="decision-agent-item">
            <h3 className="decision-agent-subtitle">Self-Improving AI</h3>
            <p className="decision-agent-text">
              Our package automatically trains a more efficient deep learning model with knowledge distillation, improving cost-effectiveness while minimizing accuracy loss.
            </p>
          </div>
        </div> */}
      </>
    );
};


const DecisionAgent = () => {
 
  return (
    <FadeInSection className="decision-agent-container">
      
      <DecisionAgentHeader />

      <DecisionAgentDemoSetup />

      <DecisionAgentOptimization />

      {/* <DecisionAgentInstructions /> */}


    </FadeInSection>
  );
};

export default DecisionAgent;
